import store from '@/store/store';
import { Nullable } from '@/utils/types';
import { formatSpaceSizeLabel } from '@/bundles/MeasurementUnits/helpers';

export const getBuildingSizeFormatted = (value: number | string): string => {
  const defaultBuildingSizeUnit = store.state.MeasurementUnits.buildingSize;
  const selectedBuildingSizeUnit = store.state.accountSettings?.properties?.building_size_type?.value;

  return formatSpaceSizeLabel(value, {
    from: defaultBuildingSizeUnit,
    to: selectedBuildingSizeUnit,
  });
};

// A missing or 0 size reads as N/A, like BuildingSizeLabel shows it.
export const getBuildingSizeLabel = (value: Nullable<number | string>): Nullable<string> => {
  return value ? getBuildingSizeFormatted(value) : null;
};
